export enum ServiceMode {
  cateringDelivery = 'CATERING_DELIVERY',
  cateringPickup = 'CATERING_PICKUP',
  curbside = 'CURBSIDE',
  delivery = 'DELIVERY',
  driveThru = 'DRIVE_THRU',
  eatIn = 'EAT_IN',
  tableService = 'TABLE_SERVICE',
  takeout = 'TAKEOUT',
}
